import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import SampleContainer from "./SampleContainer";
import NFViewContainer from "./NFViewContainer";
import ReviewsContainer from "./ReviewsContainer";

import * as selectors from "../sample.selectors";
import {setActiveTab} from '../sample.actions'
import {Tab, Tabs} from "../../../components";

class AdminView extends React.Component {
  state = {activeKey: 1};

  componentWillMount() {
    const {period, justUploaded, activeTab} = this.props;
    const activeKey = activeTab
      ? activeTab
      : period.quarterlyStatus === 'Awaiting Sample' || justUploaded ? 0 : 1;
    this.setState({activeKey});
  }

  componentWillReceiveProps(nextProps) {
    const {period, activeTab} = this.props;
    const {period: {quarterlyStatus}, justUploaded} = nextProps;

    if (period.quarterlyStatus !== quarterlyStatus) {
      const activeKey = activeTab
        ? activeTab
        : quarterlyStatus === 'Awaiting Sample' || justUploaded ? 0 : 1;
      this.setState({activeKey});
    }
  }

  onTabSelected = id => this.props.actions.setActiveTab(id);

  render() {
    const {activeKey} = this.state;
    const tabsEnabled = this.props.patients.length;

    return (
      <Tabs activeKey={activeKey} onSelect={this.onTabSelected}>
        <Tab text="Sample" render={() => <SampleContainer/>}/>
        <Tab text="Reviews" disabled={!tabsEnabled} render={() => <ReviewsContainer/>}/>
        <Tab text="NF View" disabled={!tabsEnabled} render={() => <NFViewContainer/>}/>
      </Tabs>
    )
  }
}

export default connect(
  (state) => ({
    period: selectors.currentPeriod(state),
    justUploaded: selectors.dataJustUploaded(state),
    patients: selectors.includedPatients(state),
    activeTab: selectors.activeTab(state)
  }),
  dispatch => ({
    actions: bindActionCreators({setActiveTab}, dispatch)
  })
)(AdminView);



// WEBPACK FOOTER //
// ./src/modules/sample/admin/index.js